// extracted by mini-css-extract-plugin
module.exports = {"controlButton":"_2gvSX","hidden":"fkGYl","container":"_2RCIJ","frame":"_3uwfk"};